import styled from 'styled-components';

export const Wrap = styled.div`
  flex-grow: 1;
`;
